"use strict";

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

function alias(_ref) {
  var commandService = _ref.commandService,
      compilerService = _ref.compilerService;
  return {
    name: 'alias',
    synopsis: 'alias [NAME] [COMMAND STRING]',
    description: 'Create an alias for a command string',
    execute: function execute(_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          name = _ref3[0],
          source = _ref3[1];

      var _compilerService$comp = compilerService.compileWithMetadata(source),
          command = _compilerService$comp.command,
          metadata = _compilerService$comp.metadata;

      var firstCommandName = metadata.findOne(function (_ref4) {
        var type = _ref4.type;
        return type === metadata.type.COMMAND;
      }).name;
      var firstCommand = commandService.registry[firstCommandName];
      commandService.load(function () {
        return {
          name: name,
          options: firstCommand.options,
          description: "Alias for \"".concat(source, "\""),
          execute: function execute(args, opts) {
            return command(args, opts);
          }
        };
      });
    }
  };
}

var _default = alias;
exports.default = _default;